type Options = {
  spritePath?: string;
  version?: string;
};

let _options: Options;

export default {
  getSpritePath: () => _options?.spritePath,
  getVersion: () => _options?.version || '1.0.0',
  getIconRef(): string {
    return `${this.getSpritePath()}?v=${this.getVersion()}`;
  },
  setOptions(options) {
    _options = options;
  },
};
